module.exports = __webpack_public_path__ + "static/media/comp-mixing-s.063835d3.webp";